import requestv2 from "~/utils/http-v2";

const extendApi = {
	gets : async (params) => {
		const url = 'v2/extend';
		return await requestv2.get(url, {params});
	},
	updateService : async (params) => {
		const url = `v2/extend/service`;
		return await requestv2.post(url, params);
	},
	statusEmail : async (params) => {
		const url = `v2/extend/status/email`;
		return await requestv2.post(url, params);
	},
	saveEmail : async (params) => {
		const url = `v2/extend/save/email`;
		return await requestv2.post(url, params);
	},
	sendEmail : async (params) => {
		const url = `v2/extend/send/email`;
		return await requestv2.post(url, params);
	},
	statusZalo : async (params) => {
		const url = `v2/extend/status/zalo`;
		return await requestv2.post(url, params);
	},
	sendZalo : async (params) => {
		const url = `v2/extend/send/zalo`;
		return await requestv2.post(url, params);
	},
};

export default extendApi;